import {createAction, props} from "@ngrx/store";
import {IAttachmentsFileAction} from "@shared/components/attachments/interfaces/attachments-file-action.interface";
import {
  IAttachmentsFileRequestAction
} from "@shared/components/attachments/interfaces/attachments-file-request-action.interface";
import {
  IAttachmentKnowledgeArticle
} from "@shared/components/attachments/interfaces/attachment-knowledge-article.interface";
import {
  IAttachmentKnowledgeArticleResponse
} from "@shared/components/attachments/interfaces/attachment-knowledge-article-response.interface";

export const getFile = createAction(
  '[Attachments] Get File Start',
  props<IAttachmentsFileRequestAction>()
);

export const getFileSuccess = createAction(
  '[Attachments] Get File Success',
  props<IAttachmentsFileAction>()
);

export const getFileFail = createAction(
  '[Attachments] Get File Fail',
  props<{ error: any }>()
);

export const openLink = createAction(
  '[Attachments] Open Link Start',
  props<{ loadingId: string, url: string }>()
);

export const openLinkSuccess = createAction(
  '[Attachments] Open Link Success',
  props<{ loadingId: string, url: string }>()
);

export const openLinkFail = createAction(
  '[Attachments] Open Link Fail',
  props<{ error: any }>()
);

export const getKnowledgeArticle = createAction(
  '[Attachments] Get KnowledgeArticle Start',
  props<IAttachmentKnowledgeArticle>()
);

export const getKnowledgeArticleSuccess = createAction(
  '[Attachments] Get KnowledgeArticle Success',
  props<IAttachmentKnowledgeArticleResponse>()
);

export const getKnowledgeArticleFail = createAction(
  '[Attachments] Get KnowledgeArticle Fail',
  props<{ error: any }>()
);
